import APIClient from '@/shared/http/clients/api'

const resourceName = 'controleAcessoRegistro'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const CheckIn = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}`, data, config)
const CheckOut = (id, data = {}, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/${id}`, data, config)
const Ping = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}`, data, config)

const RecordAccessControlRepository = {
  CheckIn,
  CheckOut,
  Ping
}

export default RecordAccessControlRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/recordAccessControl.js